import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BehaviorSubject, Subject} from 'rxjs';
import {Utils} from '../../../../../services/utils';
import {BusinessProcessInstanceOverrideComponent} from '../business-process-instance-override.component';
import {CustomValidator} from '../../../../../services/custom-validator';
import {BpAdministrationService} from '../../../../../services/bp-administration.service';
import {AuthenticationService} from '../../../../../services/authentication.service';
import {ReportsServiceService} from '../../../../../services/reports-service';
import {GenericModalService} from '../../../../../services/generic-modal.service';

@Component({
  selector: 'app-schedule-modal',
  templateUrl: './schedule-modal.component.html',
  styleUrls: ['../../../../../styles/business-process-configuration.css', './schedule-modal.component.css']
})
export class ScheduleModalComponent implements OnInit {

  @Input() modalTitle: string;
  utils = Utils;
  schedulingForm: FormGroup;
  objInitialState: any;
  itemSaved: Subject<boolean> = new Subject();
  submitClick = false;
  errorMessage = '';
  successMessage = '';
  pleaseWait = false;
  datetimeNow = new Date();
  showRepetitionDuration = false;
  repetitions = [
    { value: 0, name: 'Não Repetir' },
    { value: 600, name: '10 minutos' },
    { value: 900, name: '15 minutos' },
    { value: 1800, name: '30 minutos' },
    { value: 3600, name: '1 hora' }
  ];

  durations = [
    { value: 1800, name: '30 minutos' },
    { value: 3600, name: '1 hora' },
    { value: 43200, name: '12 horas' },
    { value: 86400, name: '1 dia' }
  ];

  lifeCycle = '';

  scheduleDate = function() {
    let now = this.datetimeNow;
    return {
      today: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(),
        now.getHours(), now.getMinutes(), now.getSeconds())).toISOString().substr(0, 16)
    };
  };

  get formData() { return this.schedulingForm.controls; }

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef, private bpAdmService: BpAdministrationService,
              private authService: AuthenticationService) { }

  ngOnInit() {

    this.createForm();

    this.lifeCycle = this.objInitialState.stateLifeCycles
      .filter(f => parseInt(this.objInitialState.overrideDefinition.fromStateLifeCycle, 10) === f.value)
      .map(m => m.translatedName)[0];

    console.log(this.lifeCycle);

    if (this.objInitialState.overrideDefinition.id && this.objInitialState.overrideDefinition.id > 0) {
      this.onEditSchedule();
    }
  }

  onEditSchedule() {
    this.schedulingForm.patchValue({
      schedulingId: this.objInitialState.schedulingInfo.schedulingId,
      schedulingName: this.objInitialState.overrideDefinition.name,
      schedulingStart: this.utils.zoneAndDateParse(new Date(this.objInitialState.schedulingInfo.start), 'YYYY-MM-DDTHH:mm:ss'),
      schedulingDailyFrequency: this.objInitialState.schedulingInfo.dailyFrequency,
      schedulingTaskRepetition: this.objInitialState.schedulingInfo.repetition.toString(),
      schedulingRepetitionDuration: this.objInitialState.schedulingInfo.repetitionDuration.toString(),
      schedulingEnabled: this.objInitialState.schedulingInfo.enabled
    });
    this.showRepetitionDuration = this.objInitialState.schedulingInfo.repetition > 0;
  }

  createForm() {
    this.schedulingForm = this.formBuilder.group({
      schedulingId: 0,
      schedulingName: [null, Validators.required],
      schedulingStart: [this.scheduleDate().today, Validators.required],
      schedulingDailyFrequency: [null, CustomValidator.numeric],
      schedulingTaskRepetition: [0, Validators.required],
      schedulingRepetitionDuration: null,
      schedulingEnabled: true
    });
  }

  filteredDuration() {
    const taskRepetition = parseInt(this.schedulingForm.get('schedulingTaskRepetition').value, 10);
    return this.durations.filter(f => f.value > taskRepetition);
  }

  onChangeTaskRepetition(element) {
    const taskRepetition = parseInt(element, 10);
    this.showRepetitionDuration = taskRepetition > 0;
    const frmNameDuration = 'schedulingRepetitionDuration';
    this.schedulingForm.get(frmNameDuration).setValue(null);
    if (this.showRepetitionDuration) {
      this.schedulingForm.get(frmNameDuration).setValidators(Validators.required);
    } else {
      this.schedulingForm.get(frmNameDuration).clearValidators();
    }
    this.schedulingForm.get(frmNameDuration).updateValueAndValidity();
  }

  onSave() {
    if (this.authService.checkAuthModal()) {
      this.pleaseWait = true;
      this.submitClick = true;
      this.errorMessage = '';
      this.successMessage = '';
      const data = this.schedulingForm.getRawValue();
      data.schedulingRepetitionDuration = !data.schedulingRepetitionDuration ? 0 : data.schedulingRepetitionDuration;
      let taskId = 0; // !this.objInitialState.schedulingInfo ? 0 : this.objInitialState.schedulingInfo.taskId;
      let taskType = 0;

      if (this.objInitialState.schedulingInfo) {
        taskId = this.objInitialState.schedulingInfo.taskId;
        taskType = this.objInitialState.schedulingInfo.taskType;
      }

      const overrideDefinitionData = this.objInitialState.overrideDefinition;
      overrideDefinitionData.name = data.schedulingName;
      const params = {
        overrideDefinition: overrideDefinitionData,
        schedulingInfo: {
          dailyFrequency: data.schedulingDailyFrequency,
          enabled: data.schedulingEnabled,
          repetition: data.schedulingTaskRepetition,
          repetitionDuration: data.schedulingRepetitionDuration,
          schedulingId: data.schedulingId,
          start: new Date(data.schedulingStart).toISOString(),
          taskId: taskId,
          taskType: taskType
        }
      };

      if (this.objInitialState.overrideDefinition.id && this.objInitialState.overrideDefinition.id > 0) {
        // update
        this.bpAdmService.updateSchedulingWithOverrideInstance(params).subscribe(() => {
          this.pleaseWait = false;
          this.successMessage = 'Agendamento atualizado com sucesso.';
          this.submitClick = false;

          setTimeout(() => {
            this.successMessage = '';
            this.itemSaved.next(true);
            this.bsModalRef.hide();
          }, 2500);
        }, error1 => {
          this.setErrorMessage(error1);
        });
      } else {
        // create
        this.bpAdmService.createSchedulingWithOverrideInstance(params).subscribe(returnedValue => {
          this.pleaseWait = false;
          if (returnedValue) {
            this.successMessage = 'Agendamento salvo com sucesso.';
            setTimeout(() => {
              this.successMessage = '';
              this.itemSaved.next(true);
              this.bsModalRef.hide();
            }, 2500);
          } else {
            this.errorMessage = 'Erro ao salvar o agendamento.';
          }
          this.submitClick = false;
        }, error1 => {
          this.setErrorMessage(error1);
        });
      }
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  onClose() {
    if (this.authService.checkAuthModal()) {
      this.bsModalRef.hide();
      this.itemSaved.next(false);
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  setErrorMessage(msg) {
    this.pleaseWait = false;
    this.errorMessage = msg;
    this.submitClick = false;
  }

  periodKeyDown() {
    return false;
  }

  adjustSpaces(value, formControlName) {
    Utils.adjustSpaces(value, this.schedulingForm, formControlName);
  }

}
